<template>
  <div id="app">
    <!-- 全局微信浮窗组件 -->
    <WechatFloat />

    <!-- 导航栏 -->
    <header class="header">
      <div class="container">
        <nav class="nav">
          <div class="nav__logo">
            <a href="/" class="logo-wrapper">
              <img src="@/assets/images/logo.png" alt="公司Logo"  class="logo-img" />
              <h2 style="color: var(--primary-blue);">沚洲跨境</h2>
            </a>
          </div>
          <ul class="nav__menu">
            <li class="nav__item">
              <router-link to="/" class="nav__link" active-class="nav__link--active" exact>首页</router-link>
            </li>
            <li class="nav__item">
              <router-link to="/about" class="nav__link" active-class="nav__link--active">关于我们</router-link>
            </li>
            <li class="nav__item">
              <router-link to="/service" class="nav__link" active-class="nav__link--active">核心服务</router-link>
            </li>
            <li class="nav__item">
              <router-link to="/aiproduct" class="nav__link" active-class="nav__link--active">AI产品</router-link>
            </li>
            <li class="nav__item">
              <router-link to="/contact" class="nav__link" active-class="nav__link--active">联系我们</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </header>

    <!-- 页面主体 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer__content">
          <div class="footer__top pb-lg">
            <div class="footer__logo mb-md">
              <h3 style="color: var(--primary-blue);">沚洲TikTok</h3>
              <p class="text-secondary">服务规范 · 技术驱动</p>
            </div>
            <div class="footer__links">
              <ul class="footer__link-list">
                <li><router-link to="/about" class="nav__link" active-class="nav__link--active"><a class="footer__link">关于我们</a></router-link></li>
                <li><router-link to="/service" class="nav__link" active-class="nav__link--active"><a class="footer__link">核心服务</a></router-link></li>
                <li><router-link to="/aiproduct" class="nav__link" active-class="nav__link--active"><a class="footer__link">AI产品</a></router-link></li>
                <li><router-link to="/contact" class="nav__link" active-class="nav__link--active"><a class="footer__link">联系我们</a></router-link></li>
              </ul>
            </div>
          </div>
          <div class="footer__bottom pt-md pb-md" style="border-top: 1px solid var(--border-light);">
            <p style="font-size: 14px; color: var(--text-secondary);">© 2026 沚洲跨境 版权所有</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
// 引入微信浮窗组件
import WechatFloat from './components/WechatFloat.vue'

export default {
  name: 'App',
  components: {
    WechatFloat // 注册组件
  }
}
</script>

<style scoped>
/* 原有样式不变 */
.header {
  padding: var(--spacing-md) 0;
  background-color: var(--bg-base);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-img {
  height: 70px;
  width: auto;
  margin-top:-10px ;
}

.nav__menu {
  display: flex;
  gap: var(--spacing-lg);
}

.nav__link {
  font-size: 16px;
  font-weight: 500;
  padding: var(--spacing-sm) 0;
  position: relative;
}

.nav__link--active {
  color: var(--primary-blue);
}

.nav__link--active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--primary-blue);
}

.footer {
  background-color: var(--bg-base);
  margin-top: var(--spacing-xl);
  border-top: 1px solid var(--border-light);
}

.footer__content {
  padding: var(--spacing-lg) 0;
}

.footer__link {
  color: var(--text-secondary);
  font-size: 14px;
  margin-bottom: var(--spacing-sm);
  display: inline-block;
}

.footer__link:hover {
  color: var(--primary-blue);
}

.footer__link-list {
  display: flex;
  gap: var(--spacing-lg);
}
</style>